import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const emotion = this.element.dataset.emotionTrigger
    if (!emotion) return

    console.log(`[Primeta] emotion → ${emotion}`)

    const avatarEl = document.querySelector('[data-controller="avatar"]')
    const avatarCtrl = avatarEl?.avatarController
    if (avatarCtrl) {
      avatarCtrl.setFacialEmotion(emotion)
    }

    this.element.remove()
  }
}
